<template>
<div>
    <v-toolbar dark flat dense class="grey darken-3 ma-4">
        <v-toolbar-title>Пакети MEGOGO</v-toolbar-title>
        <v-btn icon @click="getDataFromApi()" title="Оновити">
            <v-icon color="grey">mdi-cached</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-text-field v-model="search" append-icon="mdi-account-search" label="Пошук" single-line hide-details></v-text-field>
    </v-toolbar>

    <v-data-table dark :headers="headers" :items="list" :footer-props="footerProps" :search="search" class="elevation-1 grey darken-3 ma-4">
        <template v-slot:item.active="{ item }">
            <v-switch :success="(item.active == 1 ? true : false)"  :label="(item.active == 1 ? 'Вкл.' : 'Вимк.')" v-model="item.active" @change="save(item)"></v-switch>
        </template>
        <template v-slot:item.typhoon_id="props">
            <v-edit-dialog :return-value.sync="props.item.typhoon_id" @save="save(props.item)" > {{ props.item.typhoon_id }}
                <template v-slot:input>
                    <v-text-field v-model="props.item.typhoon_id" label="Назва" single-line counter></v-text-field>
                </template>
            </v-edit-dialog>
        </template>
        <template v-slot:item.typhoon_price="props">
            <v-edit-dialog :return-value.sync="props.item.typhoon_price" @save="save(props.item)" > {{ props.item.typhoon_price }}
                <template v-slot:input>
                    <v-text-field v-model="props.item.typhoon_price" label="Назва" single-line counter></v-text-field>
                </template>
            </v-edit-dialog>
        </template>

        <template v-slot:item.name="props">
            <v-edit-dialog :return-value.sync="props.item.name" @save="save(props.item)" > {{ props.item.name }}
                <template v-slot:input>
                    <v-text-field v-model="props.item.name" label="Назва" single-line counter></v-text-field>
                </template>
            </v-edit-dialog>
        </template>
        <template v-slot:item.price="props">
            <v-edit-dialog :return-value.sync="props.item.price" @save="save(props.item)" > {{ props.item.price }}
                <template v-slot:input>
                    <v-text-field v-model="props.item.price" label="Цiна" single-line></v-text-field>
                </template>
            </v-edit-dialog>
        </template>
        <template v-slot:item.description="props">
            <v-edit-dialog :return-value.sync="props.item.description" @save="save(props.item)" large  persistent> 
                {{ props.item.description }}
                <template v-slot:input>
                    <v-textarea v-model="props.item.description" label="Опис" ></v-textarea>
                </template>
            </v-edit-dialog>
        </template>
        <template v-slot:item.info="props" >
            <v-edit-dialog :return-value.sync="props.item.info" @save="save(props.item)" large  persistent > 
                {{ props.item.info}}
                <template v-slot:input>
                    <v-textarea v-model="props.item.info" label="Коментар" ></v-textarea>
                </template>
            </v-edit-dialog>
        </template>
        <template v-slot:item.image="props">
            <v-edit-dialog :return-value.sync="props.item.image" @save="save(props.item)" > {{ props.item.image }}
                <template v-slot:input>
                    <v-text-field v-model="props.item.image" label="Зображення" single-line></v-text-field>
                </template>
            </v-edit-dialog>
        </template>
        <template v-slot:no-data>
            ...
        </template>
    </v-data-table>
</div>
</template>

<script>
import {
    mapActions
} from 'vuex'

import {
    ValidationObserver,
    ValidationProvider
} from "vee-validate"

export default {
    data: () => ({
        search: '',
        f: {},
        footerProps: {
            'items-per-page-options': [20, 40, 80],
            'items-per-page-text': 'на стор.'
        },
        headers: [{
                text: 'ID',
                align: 'left',
                sortable: true,
                value: 'id',
                selected: false,
                width: '5%',
            },
            {
                text: 'Код Тайфун',
                align: 'left',
                sortable: true,
                value: 'typhoon_id',
                selected: true,
                width: '10%',
            },
            {
                text: 'Ціна Тайфун',
                align: 'left',
                sortable: true,
                value: 'typhoon_price',
                selected: true,
                width: '10%',
            },

            {
                text: 'Назва',
                align: 'left',
                sortable: true,
                value: 'name',
                selected: true,
                width: '10%',
            },
            {
                text: 'Включена',
                align: 'left',
                sortable: true,
                value: 'active',
                selected: true,
                width: '10%',
            },
            {
                text: 'Ціна',
                align: 'left',
                sortable: true,
                value: 'price',
                selected: true,
                width: '5%',
            },
            {
                text: 'Опис',
                align: 'left',
                sortable: true,
                value: 'description',
                selected: true,
                width: '30%',
            },
            {
                text: 'Коментар',
                align: 'left',
                sortable: true,
                value: 'info',
                selected: true,
                width: '30%',
            },
            {
                text: 'Зображення',
                align: 'left',
                sortable: true,
                value: 'image',
                selected: true,
                width: '10%',
            },
        ]

    }),
    computed: {
        list() {
            return this.$store.state.adminpanel.megogoList
        },
    },
    components: {
        ValidationProvider,
        ValidationObserver
    },
    methods: {
        ...mapActions(['getMegogoList', 'setSnackbar','updateMegogoItem']),
        getDataFromApi() {
            this.getMegogoList()
        },
        save(props) {
            this.updateMegogoItem(props)
            .then(
                () => this.setSnackbar(['info', 'Успiшно змiнено'])
            )
            .catch(
                error => this.setSnackbar(['error', error])
            )
        }
    },
    mounted() {
        this.getDataFromApi()
    }
}
</script>
